import { render, staticRenderFns } from "./LevelOfGuidanceIndicator.vue?vue&type=template&id=356f2dcb&"
import script from "./LevelOfGuidanceIndicator.vue?vue&type=script&lang=js&"
export * from "./LevelOfGuidanceIndicator.vue?vue&type=script&lang=js&"
import style0 from "./LevelOfGuidanceIndicator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
